import type { HTMLAttributes, ReactNode } from 'react';

export type BadgeVariant =
  | 'neutral'
  | 'bug'
  | 'suggestion'
  | 'scenario'
  | 'ok'
  | 'warn'
  | 'accent'
  | 'outline';

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: BadgeVariant;
  mono?: boolean;
  icon?: ReactNode;
};

export function Badge({
  variant = 'neutral',
  mono,
  icon,
  className,
  children,
  ...rest
}: BadgeProps) {
  const list = ['ui-badge', `ui-badge-${variant}`];
  if (mono) list.push('ui-badge-mono');
  if (className) list.push(className);
  return (
    <span className={list.join(' ')} {...rest}>
      {icon}
      {children}
    </span>
  );
}

export type TagProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: 'soon' | 'neutral';
};

export function Tag({ tone = 'neutral', className, children, ...rest }: TagProps) {
  const list = ['ui-tag'];
  if (tone === 'soon') list.push('ui-tag-soon');
  if (className) list.push(className);
  return (
    <span className={list.join(' ')} {...rest}>
      {children}
    </span>
  );
}
